module.exports = __webpack_public_path__ + "img/mango-ipad.d4c93584.png";